import { Button } from '@monksflow/monks-ui';
import { PauseIcon, PlayIcon, Volume2Icon, VolumeOffIcon } from 'lucide-react';
import { getTimecode, useMediaPlayer } from '@/features/comment-on-file';
import { useMediaElementControls } from './useMediaElementControls';
import { useTranslation } from 'react-i18next';

/**
 * Play/pause + mute + current-time / duration timecode. Renders bare — the
 * caller owns the surrounding `ControlGroup` pill, so it composes alongside the
 * fullscreen toggle in the inline hover pill (one divided block) or stands
 * alone in the fullscreen top bar.
 */
export function VideoPlayPauseControls() {
  const { t } = useTranslation('projects');

  const { mediaElement } = useMediaPlayer();
  const { state, togglePlay, toggleMute } = useMediaElementControls(mediaElement);
  return (
    <div className="flex items-center px-2 py-2 gap-2">
      <Button
        variant="ghost"
        size="mini"
        className="size-6 text-primary hover:text-primary"
        onClick={togglePlay}
        aria-label={
          state.isPlaying
            ? t('projectDetail.videoPlayPauseControls.pause')
            : t('projectDetail.videoPlayPauseControls.play')
        }
      >
        {state.isPlaying ? (
          <PauseIcon className="size-4" />
        ) : (
          <PlayIcon className="size-4 translate-x-px" />
        )}
      </Button>
      <Button
        variant="ghost"
        size="mini"
        className="size-6"
        onClick={toggleMute}
        aria-label={
          state.muted
            ? t('projectDetail.videoPlayPauseControls.unmute')
            : t('projectDetail.videoPlayPauseControls.mute')
        }
      >
        {state.muted ? <VolumeOffIcon className="size-4" /> : <Volume2Icon className="size-4" />}
      </Button>
      <div className="select-none text-xs tabular-nums">
        {getTimecode(state.currentTime)} / {getTimecode(state.duration)}
      </div>
    </div>
  );
}
